import CommonApplication from "../common/Application";
import Routes from "./config/Routes";
import UnreadNotificationCenter from "../shared/UnreadNotificationCenter";

export default class Application extends CommonApplication{
    constructor() {
        super();
        this.routes = new Routes();
    }

    afterPageChanged() {
        this.openTab();
    }

    afterBindEvents() {
        this.bindEntitySearch();
    }

    bindEntitySearch() {
        const entitySearchInput = document.getElementById('entitySearchInput');
        if (entitySearchInput) {
            entitySearchInput.addEventListener('input', function(e) {
                const searchTerm = e.target.value.toLowerCase();
                const entityList = document.getElementById('entityList');
                const entityItems = entityList.querySelectorAll('.dropdown-item');
                
                entityItems.forEach(function(item) {
                    const entityText = item.textContent.toLowerCase();
                    if (entityText.includes(searchTerm)) {
                        item.style.display = '';
                    } else {
                        item.style.display = 'none';
                    }
                });
            });
            
            // Prevent dropdown from closing when clicking on search input
            entitySearchInput.addEventListener('click', function(e) {
                e.stopPropagation();
            });
        }
    }

    loadLibraries() {
        if(this.datatable !== null){
            this.datatable.destroy();
        }

        this.datatable = $('.datatable').DataTable({
            dom: 'rtp',
            responsive: false,
            language: require('../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
            columnDefs: [
                { orderable: false, searchable: false, targets: -1 }
            ]
        })


        let $search = $('#customSearch')

        if($search.length !== 0){
            $search.keyup((e) => {
                this.datatable.search($(e.target).val()).draw();
            })
        }

        if(this.exportdatatable !== null){
            this.exportdatatable.destroy();
        }
        this.exportdatatable = $('.exportdatatable').DataTable({
            language: require('../backoffice/utils/plugins/datatables_translation/'+I18n.locale+'.json'),
            order: [[0, 'desc']],
            "lengthMenu": [
                [10, 25, 50, -1],
                [10, 25, 50, "All"]
            ],
            dom: 'Bfrtip',
            buttons: [
                'csv',
                'pageLength'
            ]
        })
    }

    setupUnreadNotifications(){
        this.unreadNotifications = new UnreadNotificationCenter({
            containerSelector: '#extranet-unread-comments',
            modalSelector: '#extranetUnreadNotificationsModal',
            listSelector: '#extranet-unread-notifications-list',
            loaderSelector: '#extranet-unread-notifications-loader',
            emptySelector: '#extranet-unread-notifications-empty',
            totalSelector: '#extranet-unread-notifications-total',
            markAllSelector: '#extranet-unread-notifications-mark-all',
            onError: (message) => {
                if (message && message.length > 0) {
                    this.errorNotification(message);
                }
            }
        });
    }

    openTab() {
        let url = document.location.toString();
        if (url.match('#')) {
            $('.nav-tabs a[href="#' + url.split('#')[1] + '"]').tab('show');
        }
    }

    getParam(param){
        let url = new URL(window.location.href);
        return url.searchParams.get(param);
    }
}